<div class="container">
  <app-nav-sidebar></app-nav-sidebar>

  <main [ngClass]="sidebarService.isOpen() ? 'open' : 'close'">
    <app-header></app-header>
    <app-sub-header></app-sub-header>

    @if (true) {
      <div class="content">
        <router-outlet />
      </div>
    }
  </main>
</div>

<app-alerta></app-alerta>
